'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var react = require('@emotion/react');
var index = require('../../../aviary-core/dist/cjs/index.cjs');

/**
 * SVG Illustration of network
 */ const Network = ({ assetColor = index.ASSET_COLORS.grey, size = index.ILLUSTRATION_DIMENSIONS.medium, ...rest })=>{
    const theme = react.useTheme();
    return /*#__PURE__*/ jsxRuntime.jsxs("svg", {
        width: size,
        height: size,
        viewBox: "0 0 104 104",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...rest,
        children: [
            /*#__PURE__*/ jsxRuntime.jsx("circle", {
                cx: "52",
                cy: "52",
                r: "52",
                fill: theme.ds5.asset[assetColor].background
            }),
            /*#__PURE__*/ jsxRuntime.jsxs("g", {
                clipPath: "url(#clip0_3427_21112)",
                children: [
                    /*#__PURE__*/ jsxRuntime.jsx("path", {
                        d: "M61.3061 77.2207C58.3311 78.6387 55.013 79.4249 51.5038 79.4249C47.9945 79.4249 44.6933 78.6387 41.7211 77.2207V79.5569C41.7211 80.4947 41.4343 81.3764 40.9141 82.1036C44.1759 83.4626 47.7639 84.2095 51.5038 84.2095C55.2436 84.2095 58.8316 83.4626 62.0935 82.1036C61.5957 81.3764 61.3061 80.4947 61.3061 79.5569V77.2207Z",
                        fill: theme.ds5.asset[assetColor]["100"]
                    }),
                    /*#__PURE__*/ jsxRuntime.jsx("path", {
                        d: "M66.0781 39.0744C69.4918 41.9103 72.0816 45.6841 73.3694 50.0307C74.3283 49.7443 75.3659 49.5899 76.4204 49.5899C77.0531 49.5899 77.6661 49.646 78.2622 49.7611C76.5357 43.0194 72.2953 37.2521 66.618 33.5176C66.6377 33.5934 66.6377 33.672 66.6377 33.7478V36.9095C66.6377 37.6957 66.4268 38.4426 66.0809 39.0744H66.0781Z",
                        fill: theme.ds5.asset[assetColor]["100"]
                    }),
                    /*#__PURE__*/ jsxRuntime.jsx("path", {
                        d: "M29.631 50.0307C30.9554 45.6813 33.5255 41.8879 36.9392 39.0744C36.5933 38.4426 36.3825 37.6957 36.3825 36.9095V33.7478C36.3825 33.672 36.3825 33.5934 36.4021 33.5176C30.7249 37.2352 26.4845 42.9998 24.7383 49.7611C25.3513 49.646 25.9671 49.5899 26.5998 49.5899C27.6542 49.5899 28.6722 49.7443 29.631 50.0307Z",
                        fill: theme.ds5.asset[assetColor]["100"]
                    }),
                    /*#__PURE__*/ jsxRuntime.jsx("path", {
                        d: "M51.5075 24.4212C55.2719 24.4212 58.3236 21.3739 58.3236 17.6149C58.3236 13.8559 55.2719 10.8086 51.5075 10.8086C47.7431 10.8086 44.6914 13.8559 44.6914 17.6149C44.6914 21.3739 47.7431 24.4212 51.5075 24.4212Z",
                        fill: theme.ds5.asset[assetColor]["500"]
                    }),
                    /*#__PURE__*/ jsxRuntime.jsx("path", {
                        d: "M40.9319 37.6376H62.0803C62.474 37.6376 62.7946 37.3175 62.7946 36.9244V33.76C62.7946 30.3372 60.5872 27.4563 57.5278 26.3809C55.8126 27.5602 53.7402 28.2537 51.5047 28.2537C49.2692 28.2537 47.1968 27.5602 45.4816 26.3809C42.4222 27.4563 40.2148 30.3372 40.2148 33.76V36.9244C40.2148 37.3175 40.5354 37.6376 40.9291 37.6376H40.9319Z",
                        fill: theme.ds5.asset[assetColor]["500"]
                    }),
                    /*#__PURE__*/ jsxRuntime.jsx("path", {
                        d: "M32.6566 68.9805C30.9497 70.1682 28.838 70.8758 26.5941 70.8758C24.3502 70.8758 22.2384 70.1682 20.5119 68.9805C17.4806 70.0727 15.293 72.9648 15.293 76.3764V79.5549C15.293 79.9368 15.6192 80.2653 16.0016 80.2653H37.1613C37.5437 80.2653 37.8699 79.9396 37.8699 79.5549V76.3764C37.8699 72.9677 35.6822 70.0727 32.651 68.9805H32.6566Z",
                        fill: theme.ds5.asset[assetColor]["500"]
                    }),
                    /*#__PURE__*/ jsxRuntime.jsx("path", {
                        d: "M26.5895 67.0462C30.3547 67.0462 33.4056 63.9996 33.4056 60.2399C33.4056 56.4801 30.3547 53.4336 26.5895 53.4336C22.8244 53.4336 19.7734 56.4801 19.7734 60.2399C19.7734 63.9996 22.8244 67.0462 26.5895 67.0462Z",
                        fill: theme.ds5.asset[assetColor]["500"]
                    }),
                    /*#__PURE__*/ jsxRuntime.jsx("path", {
                        d: "M82.4846 68.9805C80.758 70.1879 78.666 70.8758 76.4221 70.8758C74.1781 70.8758 72.0664 70.1682 70.3596 68.9805C67.3086 70.0727 65.1406 72.9648 65.1406 76.3764V79.5549C65.1406 79.9368 65.4471 80.2653 65.8492 80.2653H86.9893C87.3914 80.2653 87.7175 79.9396 87.7175 79.5549V76.3764C87.7175 72.9677 85.5299 70.0559 82.4817 68.9805H82.4846Z",
                        fill: theme.ds5.asset[assetColor]["500"]
                    }),
                    /*#__PURE__*/ jsxRuntime.jsx("path", {
                        d: "M69.6133 60.2399C69.6133 63.9996 72.6642 67.0462 76.4294 67.0462C80.1945 67.0462 83.2455 63.9996 83.2455 60.2399C83.2455 56.4801 80.1945 53.4336 76.4294 53.4336C72.6642 53.4336 69.6133 56.4801 69.6133 60.2399Z",
                        fill: theme.ds5.asset[assetColor]["500"]
                    })
                ]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("defs", {
                children: /*#__PURE__*/ jsxRuntime.jsx("clipPath", {
                    id: "clip0_3427_21112",
                    children: /*#__PURE__*/ jsxRuntime.jsx("rect", {
                        width: "72.4211",
                        height: "73.4035",
                        fill: "white",
                        transform: "translate(15.293 10.8086)"
                    })
                })
            })
        ]
    });
};

exports.Network = Network;
//# sourceMappingURL=Network.cjs.map
